module.exports = __webpack_public_path__ + "img/windowsLink1.bf1151c0.png";